<!-- @format -->

<template>
	<el-row :gutter="6">
		<el-col :span="24">
			<el-button size="small" @click="onAdd">新增</el-button>
		</el-col>
		<el-col :span="4" />
		<el-col :span="9">
			<label class="label">标签页名称</label>
		</el-col>

		<draggable
			:list="value"
			item-key="pcProps.label"
			class="params-drag"
			v-bind="{
				group: { name: 'tabs-params', pull: false, put: false },
				sort: true,
				handle: '.params-drag-icon',
				ghostClass: 'params-drag-ghost',
				animation: 300,
			}"
		>
			<template #item="{ element: item }: { element: Container }">
				<el-row :gutter="6">
					<el-col :span="4" style="display: flex; justify-content: space-between">
						<span class="params-drag-icon">
							<el-icon size="18" style="display: inline"><Rank /></el-icon>
						</span>
						<el-checkbox
							:model-value="item.isActive"
							class="params-checkbox"
							size="large"
							@change="(e:boolean) => onChecked(e, item.pcProps.label!)"
						/>
					</el-col>
					<el-col :span="18">
						<el-input v-model="item.pcProps.label" size="small" placeholder="请输入编码"></el-input>
					</el-col>
					<el-col :span="2">
						<el-icon v-if="value.length > 1" class="form-item-content-icon" @click.stop.prevent="onDel(item)">
							<Delete />
						</el-icon>
					</el-col>
				</el-row>
			</template>
		</draggable>
	</el-row>
</template>

<script setup lang="ts">
	import { useDragStoreWithOut } from '../../store';
	import { type Container } from '../../types';
	import { draggable } from '@/components';

	interface Props {
		modelValue: string;
	}

	withDefaults(defineProps<Props>(), {});

	const name = inject<string>('name');

	const dragStore = useDragStoreWithOut(name);

	const value = computed({
		get() {
			return (dragStore.selectField as Container)?.children || [];
		},
		set(val) {
			(dragStore.selectField as Container).children = val;
		},
	});

	const onAdd = () => {
		value.value.push({
			category: 'container',
			type: 'tabs',
			code: '',
			pcProps: {
				label: 'tab1',
				cols: '24',
			},
			children: [],
			isActive: false,
		});
	};

	const onDel = (item: Container) => {
		value.value = value.value.filter((itm) => itm.pcProps.label !== item.pcProps.label);
	};

	const onChecked = (checked: boolean, label: string) => {
		if (checked) {
			value.value = value.value.map((itm) => ({ ...itm, isActive: itm.pcProps.label === label }));
		} else {
			value.value = value.value.map((itm) => ({ ...itm, isActive: false }));
		}
	};
</script>

<style scoped lang="scss">
	.params-drag {
		padding: 0 10px;
		width: 100%;

		.params-drag-icon {
			padding: 2px 0px 0px 10px;
			cursor: move;
		}

		.form-item-content-icon {
			cursor: pointer;
		}

		.params-drag-ghost {
			outline: 1px solid #333;
		}

		.params-checkbox {
			:deep(.el-checkbox__input) {
				margin-bottom: 14px;
			}
		}
	}
</style>
